import Header from "../../components/Header"
import HeaderImage from '../../images/header_bg_2.jpg'
import { MdEmail } from "react-icons/md"
import {BsMessenger} from "react-icons/bs"
import { IoLogoWhatsapp } from "react-icons/io"


import './contacts.css'

const Contacts = () => {
  return (
    <>
    <Header title="Reach Us" image={HeaderImage}>
        Quis in non sunt, sed possimus odio error,
        deserunt debitis dolore repellat esse magni,
         eos recusandae autem ullam officia dolor nam sint.
    </Header>
    <section className="contacts">
      <div className="container contacts__container">
        <h2 className="call center">Reach Us</h2>
        <div className="contact__wrapper">
          <a href="mailto:dev@ladwongdevelopers.com" target="_blank" rel="noreferrer noopener"><MdEmail/></a>
          <a href="https://m.me/" target="_blank" rel="noreferrer noopener"><BsMessenger/></a>
          <a href="https://wa.me/+256780909566" target="_blank" rel="noreferrer noopener"><IoLogoWhatsapp/></a>
        </div>
      </div>
    </section>
    <br />
    <div className="call center">
      
      <p>+256 780 909 566</p>
      <p>Monday - Friday: 9am - 6pm</p>

      <p>Saturday: 9am - 5pm</p>

      <p>Sunday: Closed</p>
    </div>
    <div className="map center">
      <iframe
        title="Google Map of Muyenga Tank Hill, Kampala, Uganda"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2587.5460972360515!2d32.61173477561444!3d0.29587380166919997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x177dbc39ae29c471%3A0x88f9a9ec07f2a3ea!2sMuyenga%20Tank%20Hill%2C%20Kampala%2C%20Uganda!5e1!3m2!1sen!2sus!4v1736008598536!5m2!1sen!2sus"
        width="600"
        height="450"
        style={{ border: 1.5, width: '80%', height: '500px' }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>


    </>
  )
}

export default Contacts